<template>
  <Header />

  <FriendAssign :friend-i-d="friend.id" />

  <Footer />
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import FriendAssign from "@/components/FriendAssign.vue";

export default {
  name: "PeopleView",
  components: {
    Header,
    Footer,
    FriendAssign,
  },
  created() {
    if (!this.$store.state.friendMap.find(item => item.id === this.$route.params.id)) {
      this.$router.push({ name: 'People' })
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user.loggedIn;
    },
  },
  data() {
    return {
      friend: this.$store.state.friendMap.find(item => item.id === this.$route.params.id),
    }
  },
};
</script>
